import React from 'react';
import { useHistory } from 'react-router-dom';

import BackToPipelineOverviewButton from 'app/components/BackToPipelineOverviewButton';

export default function BackButton() {
  const history = useHistory();
  const {
    location: {
      state: { pipeline },
    },
  } = history;

  return <BackToPipelineOverviewButton pipelineId={pipeline.id} pipelineName={pipeline.name} />;
}
